import Link from 'apollo-link-queue';

export const QueueLink = new Link();
